import { useState, useCallback } from "react";
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";

export const usePhoneNumber = (initialValue = "") => {
  const [phoneNumber, setPhoneNumber] = useState(initialValue);
  const [error, setError] = useState("");

  const handlePhoneChange = useCallback((value) => {
    setPhoneNumber(value || "");
    setError("");

    if (value && !isValidPhoneNumber(value)) {
      setError("Please enter a valid phone number");
    }
  }, []);

  const getPhoneData = useCallback(() => {
    if (!phoneNumber) {
      return {
        country_phone_code: "",
        cellphone: "",
        isValid: false,
      };
    }

    try {
      const parsed = parsePhoneNumberFromString(phoneNumber);
      if (!parsed) {
        return {
          country_phone_code: "",
          cellphone: "",
          isValid: false,
        };
      }

      return {
        country_phone_code: parsed.countryCallingCode,
        cellphone: parsed.nationalNumber,
        isValid: parsed.isValid(),
      };
    } catch {
      return {
        country_phone_code: "",
        cellphone: "",
        isValid: false,
      };
    }
  }, [phoneNumber]);

  const reset = useCallback(() => {
    setPhoneNumber("");
    setError("");
  }, []);

  return {
    phoneNumber,
    error,
    handlePhoneChange,
    getPhoneData,
    reset,
    isValid: !error && (phoneNumber ? isValidPhoneNumber(phoneNumber) : true),
  };
};
